module.exports = __webpack_public_path__ + "img/BADT.461f6280.svg";